<template>
  <div class="apply-list-wrapper">
    <el-dialog
      :visible.sync="isShow"
      width="650px"
      :close-on-click-modal="false"
      :before-close="handleApplyListCloseBefore"
    >
      <template slot="title">
        <div class="apply-list-title">注册申请审核记录</div>
      </template>
      <div class="dialog-wrapper" :class="auditList.length > 4 ? 'h450' : ''">
        <vue-scroll :ops="vuescrollOpt">
          <div class="list-wrapper">
            <template v-if="auditList.length">
              <div
                class="audit-item"
                v-for="(item, index) in auditList"
                :key="index"
              >
                <div class="status-box">
                  <div class="border">
                    {{ item.type | alterationAuditFilter }}
                  </div>
                  <div class="line"></div>
                </div>
                <div class="content-box">
                  <div class="time-box">
                    <span>{{ item.create_time | time(false) }}</span>
                    <span style="margin-left: 20px" v-if="item.type === 'submit_transfer'">提交人：{{ item.name }}</span>
                    <span style="margin-left: 20px" v-else-if="item.name">审核人：{{item.org_abbreviation}}<span v-if="item.name">({{ item.name }})</span></span>
                  </div>
                  <div class="info-box" >
                    <div class="info">
                      <div class="info-line" v-if="item.type !== 'submit_transfer'">
                        审核结果：{{ item.status | alterationAuditFilter}}
                      </div>
                      <template v-if="item.type !== 'submit_transfer'">
                        <div class="info-line">
                          备注：{{ item.opinion || '--' }}
                        </div>
                      </template>
                      <template v-else>
                        <div class="info-line">
                          提交申请
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div v-else class="dialog-wrapper" style="padding: 30px 0">
              <yioks-empty h="150px"></yioks-empty>
            </div>
          </div>
        </vue-scroll>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { alterationAuditFilter } from "@/assets/js/yioksFilters";
import createScrollOpt from "@/assets/js/vuescrollOption";
export default {
  components: {
    "yioks-empty": () => import("@/components/Tips/Empty-grey"),
  },
  props: {
    auditList: {
      type: Array,
      required: true,
      default: () => {
        return [];
      },
    },

    isShow: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      vuescrollOpt: createScrollOpt(true),
    };
  },

  filters: {
    alterationAuditFilter,
  },

  methods: {
    setDialogStatus(flag) {
      this.$emit("update:isShow", flag);
    },

    handleApplyListCloseBefore() {
      this.setDialogStatus(false);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.apply-list-wrapper
  font-size $font_size_medium
  .apply-list-title
    padding-bottom 10px
    border-bottom 1px solid #ccc
    color #666
    font-weight 600
    font-size 18px
  .apply-list-content
    padding 10px
    .apply-item
      &:not(:last-child)
        margin-bottom 15px
/deep/.el-dialog__body
  padding 10px 10px 10px 20px
.dialog-wrapper
  // height: 450px
  .list-wrapper
    margin 0px 35px 0px 25px
    .audit-item
      display flex
      justify-content space-between
      margin-bottom 15px
      .status-box
        width 80px
        display flex
        justify-content center
        position relative
        .border
          border 1px solid #ccc
          padding: 0 2px;
          text-align: center;
          width 45px
          height 45px
          border-radius 50%
          display flex
          align-items center
          justify-content center
          z-index 99
          background #fff
          text-align: center
      .content-box
        flex 1
        .time-box
          font-size 1.2em
        .info-box
          border 1px solid #ccc
          padding 5px 10px
          box-sizing border-box
          border-radius 3px
          margin 10px 0
          display flex
          justify-content space-between
          .info
            flex 1
          .man
            width 140px
      &:not(:last-child)
        .status-box
          .line
            height 100%
            width 2px
            background-color #ccc
            position absolute
            bottom -17px
.h450
  height 450px
</style>
